module.exports = __webpack_public_path__ + "img/img2.1c988750.png";